import { render } from "./EducationModal.vue?vue&type=template&id=3ee6966b&scoped=true"
import script from "./EducationModal.vue?vue&type=script&lang=js"
export * from "./EducationModal.vue?vue&type=script&lang=js"

import "./EducationModal.vue?vue&type=style&index=0&id=3ee6966b&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee6966b"]])

export default __exports__